import { Task } from "@/components/kanban/types";

export const isTaskOverdue = (task: Task): boolean => {
  if (!task.dueDate || task.status === "done") {
    return false;
  }
  
  const now = new Date();
  const dueDate = new Date(task.dueDate);
  
  // Set time to end of day for due date and start of day for current date
  dueDate.setHours(23, 59, 59, 999);
  now.setHours(0, 0, 0, 0);
  
  return dueDate < now;
};